import { AddStock } from '@/src/pages/Pharmacist/Drug Inventory/Product List/Modals/AddStock'
import CreateProduct from '@/src/pages/Pharmacist/Drug Inventory/Product List/Modals/CreateProduct'
import EditProduct from '@/src/pages/Pharmacist/Drug Inventory/Product List/Modals/EditProduct'
import ShowStock from '@/src/pages/Pharmacist/Drug Inventory/Product List/Modals/ShowStock'
import { InventoryDetails } from '@/src/pages/Pharmacist/Drug Inventory/Product List/Product Details/Modals/InventoryDetails'
import {
  ApproveAllRequisitions,
  ApproveRequisitionDrugs,
  AssessRequisition,
  DeclineRequisition,
  RequisitionDetails
} from '@/src/pages/Pharmacist/Drug Inventory/Requisitions/Actions/Modals'
// import AssessRequisition from '@/src/pages/Pharmacist/Drug Inventory/Requisitions/Actions/Modals/AssessRequisition'
import { Fragment } from 'react/jsx-runtime'
import { useModalStore } from './modalstore'

export enum PHARMACY_MODAL_TYPE {
  CREATE_PRODUCT = 'CREATE_PRODUCT',
  UPDATE_PRODUCT = 'UPDATE_PRODUCT',
  ADD_STOCK = 'ADD_STOCK',
  SHOW_STOCK_LIST = 'SHOW_STOCK_LIST',
  INVENTORY_DETAILS = 'INVENTORY_DETAILS',
  REQUISITION_DETAILS = 'REQUISITION_DETAILS',
  REQUISITION_APPROVE_DRUGS = 'REQUISITION_APPROVE_DRUGS',
  REQUISITION_APPROVE_ALL = 'REQUISITION_APPROVE_ALL',
  REQUISITION_DECLINE = 'REQUISITION_DECLINE',
  REQUISITION_ASSESS = 'REQUISITION_ASSESS'
}

const Modals = [
  {
    component: CreateProduct,
    value: PHARMACY_MODAL_TYPE.CREATE_PRODUCT
  },
  {
    component: AddStock,
    value: PHARMACY_MODAL_TYPE.ADD_STOCK
  },
  {
    component: EditProduct,
    value: PHARMACY_MODAL_TYPE.UPDATE_PRODUCT
  },
  {
    component: ShowStock,
    value: PHARMACY_MODAL_TYPE.SHOW_STOCK_LIST
  },
  {
    component: InventoryDetails,
    value: PHARMACY_MODAL_TYPE.INVENTORY_DETAILS
  },
  {
    component: RequisitionDetails,
    value: PHARMACY_MODAL_TYPE.REQUISITION_DETAILS
  },
  {
    component: AssessRequisition,
    value: PHARMACY_MODAL_TYPE.REQUISITION_ASSESS
  },
  {
    component: ApproveRequisitionDrugs,
    value: PHARMACY_MODAL_TYPE.REQUISITION_APPROVE_DRUGS
  },
  {
    component: ApproveAllRequisitions,
    value: PHARMACY_MODAL_TYPE.REQUISITION_APPROVE_ALL
  },
  {
    component: DeclineRequisition,
    value: PHARMACY_MODAL_TYPE.REQUISITION_DECLINE
  }
]

export const PharmacyModal = () => {
  const { activeModal, closeModal } = useModalStore()

  return (
    <>
      {Modals?.map(({ component: Component, value }) => {
        const active = {
          ...activeModal.find(({ modal }) => modal === value)?.modalProps
        }
        const reset = active.reset

        return (
          <Fragment key={value}>
            {activeModal.some(({ modal }) => modal === value) && (
              <Component
                isOpen={activeModal.some(({ modal }) => modal === value)}
                key={value}
                onClose={() => {
                  closeModal(value, reset)
                }}
                {...activeModal.find(({ modal }) => modal === value)?.modalProps}
              />
            )}
          </Fragment>
        )
      })}
    </>
  )
}
